<script lang="ts" setup>
import { CoinQuestTaskType, CoinQuestType } from "@/types/coin";
import { getDisplayDateTime } from "@/modules/common";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  type: CoinQuestType;
  taskType?: CoinQuestTaskType;
  title: string;
  amount: number;
  time: string;
}>();
const { t } = useI18n();

const getTaskName = (type: CoinQuestTaskType) => {
  switch (type) {
    case CoinQuestTaskType.Visit:
      return t("Coin.dailyCheck");
    case CoinQuestTaskType.SetAvatar:
      return t("Coin.updateAvatarTask");
    case CoinQuestTaskType.Get3Reply:
      return t("Coin.reviewTask");
    case CoinQuestTaskType.Send5Emoji:
      return t("Coin.postReactionTask");
    case CoinQuestTaskType.SetBio:
      return t("Coin.bioTask");
    default:
      return t("Coin.buyTicket");
  }
};

const getTaskTypeText = (type: CoinQuestType) => {
  switch (type) {
    case CoinQuestType.DailyTask:
      return t(`Coin.dailyTask`);
    case CoinQuestType.Award:
      return t(`Coin.reward`);
    case CoinQuestType.CommunityActivity:
    case CoinQuestType.ReviewerTicket:
      return t(`Coin.community`);
    case CoinQuestType.OneTimeTask:
    default:
      return t(`Coin.oneTimeTask`);
  }
};
</script>
<template>
  <div class="flex flex-col p-4 border-b">
    <div class="flex justify-between">
      <div class="line-clamp-1">
        {{ taskType ? getTaskName(taskType) : title }}
      </div>
      <div class="text-primary">
        {{ amount > 0 ? "+" : "" }}{{ amount }}
        <slot name="coin-icon">
          <i class="iconfont icon-coin text-base-content/50" />
        </slot>
      </div>
    </div>
    <div class="flex justify-between">
      <div class="flex justify-end items-center gap-1">
        <div class="text-base-content/50">
          {{ getTaskTypeText(props.type) }}
        </div>
      </div>
      <div class="text-base-content/50">
        {{ getDisplayDateTime(time) }}
      </div>
    </div>
  </div>
</template>
